import gtl from "@gaming/gtl";
import { AppLaunchData, GtlAppLaunchType, GtlEventType } from "@gaming/gtl/lib/Types";

import { incrementCorrelationVector } from "./correlationVector";
import { getCookie } from "./getCookie";
import { getLocaleFromUrl } from "./urlHelper";

export const correlationVector = incrementCorrelationVector();

const checkGlobalPrivacyControl = () => {
  if ("globalPrivacyControl" in navigator) {
    const gpcEnabled = navigator.globalPrivacyControl;
    return gpcEnabled;
  } else {
    return null;
  }
};

export const registerGtlClientSide = () => {
  const gpcStatus = checkGlobalPrivacyControl();
  const thirdPartyAdsOptOut = getCookie("3PAdsOptOut");
  gtl.registerProvider("OnboardingHub", {
    gpcDataSharingOptIn: gpcStatus === true ? false : thirdPartyAdsOptOut === "1" ? false : true,
  });
  gtl.setExtendedDataValue("environment", window.location.hostname);
  gtl.startGamingTelemetrySession(undefined, correlationVector);
  const launchDataInfo: AppLaunchData = {
    ActivationPageName: "OnboardingHub front-end side",
  };
  gtl.writeAppLaunch(GtlAppLaunchType.Launch, launchDataInfo);
  gtl.setExtendedDataValue("locale", getLocaleFromUrl());
  gtl.setEventAsRequired(GtlEventType.AppAction);
  gtl.setEventAsRequired(GtlEventType.Error);
  gtl.setEventAsRequired(GtlEventType.PageView);
  gtl.setEventAsRequired(GtlEventType.PageAction);
  gtl.setEventAsRequired(GtlEventType.AppLaunch);
};

export const unregisterGtl = () => {
  gtl.stopGamingTelemetrySession(true, "AUTOCOMPUTE_DURATION");
};
